export const ASPECT_RATIO = '6/9';
export const GAP = 4;
